import { Moment } from "moment";

export enum RequestNewIdReason {
  MISSING_PROOF = "MISSING_PROOF",
  OUTDATED_PROOF = "OUTDATED_PROOF",
  INVALID_PROOF = "INVALID_PROOF",
}

export interface NewProofSelectOption {
  label: string;
  value: RequestNewIdReason;
}

export function newProofSelectOptions(): NewProofSelectOption[] {
  return [
    {
      label: "Missing proof",
      value: RequestNewIdReason.MISSING_PROOF,
    },
    {
      label: "Outdated proof",
      value: RequestNewIdReason.OUTDATED_PROOF,
    },
    {
      label: "Invalid Proof",
      value: RequestNewIdReason.INVALID_PROOF,
    },
  ];
}

export interface MemberEvent {
  id: string;
  createdAt: Moment;
  memberId: string;
  type: string;
  description: string;
  issuer: string;
  details: string;
}

export enum MemberStatus {
  WAITING_FOR_APPROVAL = "WAITING_FOR_APPROVAL",
  WAITING_FOR_PROOF = "WAITING_FOR_PROOF",
  REJECTED = "REJECTED",
  FREE_TRIAL_ENDED = "FREE_TRIAL_ENDED",
  NON_RENEWAL = "NON_RENEWAL",
}

export enum ProfileStatus {
  EXPIRED_CARD = "EXPIRED_CARD",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  FAILED_PAYMENT = "FAILED_PAYMENT",
  WAITING_FOR_PROOF = "WAITING_FOR_PROOF",
  OUT_OF_DATE_PROOF = "OUT_OF_DATE_PROOF",
  NOT_APPROVED_PROOF = "NOT_APPROVED_PROOF",
  WAITING_FOR_APPROVAL = "WAITING_FOR_APPROVAL",
  REJECTED = "REJECTED",
  ACTIVE = "ACTIVE",
  FREE_TRIAL_ENDED = "FREE_TRIAL_ENDED",
  NON_RENEWAL = "NON_RENEWAL",
  NOT_VALIDATED = "NOT_VALIDATED",
  WAITING_FOR_PERSONAL_INFORMATION = "WAITING_FOR_PERSONAL_INFORMATION",
  WAITING_FOR_PAYMENT_DETAILS = "WAITING_FOR_PAYMENT_DETAILS",
}

export enum StripePaymentError {
  EXPIRED_CARD = "EXPIRED_CARD",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  FAILED_PAYMENT = "FAILED_PAYMENT",
}

export enum ProofStatus {
  WAITING_FOR_PROOF = "WAITING_FOR_PROOF",
  OUT_OF_DATE_PROOF = "OUT_OF_DATE_PROOF",
  NOT_APPROVED_PROOF = "NOT_APPROVED_PROOF",
}

export enum RegistrationStatus {
  WAITING_FOR_VALIDATION = "WAITING_FOR_VALIDATION",
  WAITING_FOR_PERSONAL_INFORMATION = "WAITING_FOR_PERSONAL_INFORMATION",
  WAITING_FOR_PAYMENT_DETAILS = "WAITING_FOR_PAYMENT_DETAILS",
  WAITING_FOR_PROOF_OF_EMPLOYMENT = "WAITING_FOR_PROOF_OF_EMPLOYMENT",
}

export interface MemberProfile {
  codeId: string;
  employer: string;
  employerId: string;
  jobTitle: string;
  jobTitleId: string;
  managementLevel: string;
  managementLevelId: string;
  areaOfBusiness: string;
  areaOfBusinessId: string;
  promoCodeId: string;
  promoCodeName: string;
  promoCode: string;
  proofResourceId: string;
  locationId: string;
  planId: string;
  redemptionsCount: number;
  hasMobileApp: boolean;
  status: MemberStatus;
  profileStatus: ProfileStatus;
  lastStripeError: StripePaymentError | null;
  proofOfEmploymentStatus: ProofStatus | null;
  registrationStatus: RegistrationStatus | null;
  isVip: boolean;
  isFree: boolean;
  isValidated: boolean;
  isStaff: boolean;
  lastSubscriptionType: string;
  lastSubscriptionPromoCode: string;
}

export interface WebMemberProfile extends MemberProfile {
  subscriptionName: string;
  subscriptionEndDate: Moment;
  freeTrialEndDate: Moment;
  subscriptionCancelledDate: Moment;
  isOld: boolean;
}

export interface MemberDevice {
  token: string | null;
  createdAt: string;
  updatedAt: string;
  isValid: boolean | null;
  coordinates: boolean;
  platform: string | null;
  appVersion: string | null;
  installationId: string | null;
}

export interface JobTitle {
  id: string;
  name: string;
  archivedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ManagementLevel {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export interface AreaOfBusiness {
  id: string;
  name: string;
  groupName: string;
  createdAt: string;
  updatedAt: string;
}

export interface Employer {
  id: string;
  name: string;
  websiteUrl: string;
  numberOfVenues: number;
  numberOfEmployees: number;
  businessTypeId: string;
  businessClassificationId: string;
  archivedAt: string | null;
  createdAt: string;
  updatedAt: string;
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/members.interfaces.ts